import React from 'react';
import { NavigationLevel } from '../../Utilities/NavigationUtility';
import './Section.css';

interface Props {
    childComp?: React.ReactNode;
    navigationLevel?: NavigationLevel;
}

const Section: React.FC<Props> = ({ childComp, navigationLevel }) => {
    return (
        <div className="section px-0 py-2" id={navigationLevel}>
            <div className="container">
                {childComp}
            </div>
        </div>
    )
}

export default Section
